import { useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fetchTransitOperation } from '../api/fetchTransitOperation'
import { submitPresentationNotification } from '../api/http'

function usePresentationNotification(transitOperationId: number | null) {
  const qc = useQueryClient()

  const sendPresentationNotification = async () => {
    if (!transitOperationId) throw new Error('Missing transit operation id')
    await submitPresentationNotification({ id: transitOperationId })

    const updated = await fetchTransitOperation(transitOperationId)
    qc.setQueriesData(
      {
        queryKey: QueryKeys.transitOperation.detailById({ id: updated.id as number }),
      },
      (prev) => {
        if (!prev) return prev
        return { ...prev, ...updated }
      },
    )
    await qc.invalidateQueries({
      queryKey: QueryKeys.eventLog.all(transitOperationId),
    })

    return updated
  }

  return {
    sendPresentationNotification,
  }
}

export default usePresentationNotification
